import React, { useState } from "react";
import { ReactComponent as Arrow } from '../../assets/ArrowDown.svg';
import { ReactComponent as ArrowSmall } from '../../assets/dropdownSmall.svg';

interface Props {
  options: string[];
  selectedOption: string;
  onChange: (option: string) => void;
}

const CustomDropdown: React.FC<Props> = ({ options, selectedOption, onChange }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleDropdownToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (option: string) => {
    onChange(option);
    setIsOpen(false); // Close the dropdown after selection
  };

  return (
    <div className="relative w-full">
      <button
        onClick={handleDropdownToggle}
        className="w-full md:h-14 h-14 flex items-center justify-between px-4 rounded-[5px] border-[1px] border-[rgba(102,102,102,0.35)] border border-[#D8DADC]"
      >
        {/* semibold-text */}
        <p className="text-[#424242] text-xs md:text-base">{selectedOption}</p>
        <div className="ml-[10px]">
          {isOpen ? <Arrow className="rotate-180 transition-transform" /> : <Arrow className="transition-transform" />}
        </div>
      </button>

      {/* Dropdown options */}
      {isOpen && (
        <div className="absolute left-0 w-full mt-1 rounded-[5px] bg-white shadow-md z-10">
          {options.map((option) => (
            <div
              key={option}
              onClick={() => handleOptionSelect(option)}
              className="cursor-pointer px-4 py-2 text-sm text-[#424242] hover:bg-[#f0f0f0] "
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
